import { useState } from "react";
import { faqs } from "@/mocks/faqs";
import SectionHeading from "@/components/base/SectionHeading";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="border-t border-background-200 bg-background-100">
      <div className="w-full px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="常见问题"
          title="第一次来，先把这些看完"
          desc="关于更新节奏、内容原则和查找方式，这里集中回答了几个最常被问到的问题。"
          align="center"
        />

        <div className="mx-auto mt-9 max-w-3xl space-y-3">
          {faqs.map((item, index) => {
            const isOpen = open === index;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : index)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="font-heading text-base font-bold text-foreground-950">
                    {item.q}
                  </span>
                  <i
                    className={`shrink-0 text-lg text-primary-600 transition-transform ${
                      isOpen ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}